var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"m-auto w-w-75p max-w-340 h-auto mb-10",attrs:{"src":require("@/assets/images/tenant-logo.png"),"id":"logoTitle"}})}
var staticRenderFns = []

export { render, staticRenderFns }